import { type SVGProps } from 'react';

export const MailBoldIcon = (props: SVGProps<SVGSVGElement>): React.ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M21 5H3v14h18V5ZM4 6.38V6h16v.374L12 12 4 6.38Zm0 1.235V18h16V7.61l-8 5.626-8-5.621Z"
        clipRule="evenodd"
      />
    </svg>
  );
};
